/* ============================================
   Raja Waqar Luxury – Dawn Theme JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* --- Starfield Canvas --- */
  (function () {
    const canvas = document.getElementById('rw-starfield');
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let W, H, stars = [];

    function resize() {
      W = canvas.width = window.innerWidth;
      H = canvas.height = window.innerHeight;
    }

    function createStars(n) {
      stars = [];
      for (let i = 0; i < n; i++) {
        stars.push({
          x: Math.random() * W,
          y: Math.random() * H,
          r: Math.random() * 1.2 + 0.2,
          a: Math.random(),
          speed: Math.random() * 0.003 + 0.001,
          dir: Math.random() > 0.5 ? 1 : -1
        });
      }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);
      stars.forEach(s => {
        s.a += s.speed * s.dir;
        if (s.a > 1 || s.a < 0) s.dir *= -1;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(201,168,76,${s.a * 0.6})`;
        ctx.fill();
      });
      requestAnimationFrame(draw);
    }

    window.addEventListener('resize', function () { resize(); createStars(160); });
    resize();
    createStars(160);
    draw();
  })();

  /* --- Gallery Thumbnails (Product Page) --- */
  document.querySelectorAll('.rw-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const mainImg = document.getElementById('rw-main-product-img');
      if (mainImg) mainImg.src = this.dataset.src;
      document.querySelectorAll('.rw-gallery__thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* --- Quantity Selector --- */
  document.querySelectorAll('.rw-qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.parentNode.querySelector('.rw-qty-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'plus') val++;
      else if (this.dataset.action === 'minus' && val > 1) val--;
      input.value = val;
    });
  });

  /* --- Variant Selector --- */
  document.querySelectorAll('.rw-variant-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      if (this.disabled) return;
      document.querySelectorAll('.rw-variant-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
      const hiddenId = document.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = this.dataset.variantId;
      const priceEl = document.querySelector('.rw-product__price');
      if (priceEl && this.dataset.price) priceEl.textContent = this.dataset.price;
    });
  });

  /* --- Add to Cart Notification --- */
  const cartForms = document.querySelectorAll('form[action*="cart/add"]');
  const notification = document.getElementById('rw-cart-notification');
  cartForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      if (!notification) return;
      setTimeout(function () {
        notification.hidden = false;
        setTimeout(function () { notification.hidden = true; }, 3500);
      }, 600);
    });
  });

  /* --- FAQ Accordion --- */
  document.querySelectorAll('.rw-faq__question').forEach(btn => {
    btn.addEventListener('click', function () {
      const item = this.closest('.rw-faq__item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.rw-faq__item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* --- Smooth scroll for anchor links --- */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* --- Header scroll shadow --- */
  const header = document.querySelector('.rw-header-wrapper');
  if (header) {
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 10 ? '0 4px 32px rgba(0,0,0,0.5)' : 'none';
    }, { passive: true });
  }

});

/* ============================================
   MERGED FROM W LUXURY PERFUMES THEME JS
   Gold Cursor · Exit Popup · Quick View · Bundle Builder
   Size Selector · Cart Counter · Search · Scroll Reveal
   Dark/Light Mode Toggle · Sticky ATC Bar · Fragrance Tabs
   ============================================ */

/* ---- GOLD LUXURY CURSOR (Desktop Only) ---- */
(function rwInitCursor() {
  var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouchDevice) return;
  var dot = document.getElementById('cursor-dot');
  var ring = document.getElementById('cursor-ring');
  if (!dot || !ring) return;
  var ringX = 0, ringY = 0, mouseX = 0, mouseY = 0, ease = 0.12;
  document.addEventListener('mousemove', function(e) {
    mouseX = e.clientX; mouseY = e.clientY;
    dot.style.left = mouseX + 'px'; dot.style.top = mouseY + 'px';
  });
  document.addEventListener('mouseleave', function() { dot.style.opacity = '0'; ring.style.opacity = '0'; });
  document.addEventListener('mouseenter', function() { dot.style.opacity = '1'; ring.style.opacity = '1'; });
  document.addEventListener('mousedown', function() { dot.style.transform = 'translate(-50%,-50%) scale(0.7)'; });
  document.addEventListener('mouseup', function() { dot.style.transform = 'translate(-50%,-50%) scale(1)'; });
  function addHover(sel) {
    document.querySelectorAll(sel).forEach(function(el) {
      el.addEventListener('mouseenter', function() { dot.classList.add('expanded'); ring.classList.add('expanded'); });
      el.addEventListener('mouseleave', function() { dot.classList.remove('expanded'); ring.classList.remove('expanded'); });
    });
  }
  addHover('a, button, [role="button"], .rw-product-card, .category-tile, .product-card');
  (function animateRing() {
    ringX += (mouseX - ringX) * ease; ringY += (mouseY - ringY) * ease;
    ring.style.left = ringX + 'px'; ring.style.top = ringY + 'px';
    requestAnimationFrame(animateRing);
  })();
})();

/* ---- SCROLL REVEAL ---- */
(function rwInitScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = document.querySelectorAll('.scroll-reveal');
  if (!els.length) return;
  var obs = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('revealed'); obs.unobserve(e.target); }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
  els.forEach(function(el) { obs.observe(el); });
})();

/* ---- EXIT INTENT POPUP ---- */
(function rwInitExitPopup() {
  var KEY = 'rw_exit_shown';
  if (sessionStorage.getItem(KEY)) return;
  var overlay = document.getElementById('exit-popup-overlay');
  var closeBtn = document.getElementById('exit-popup-close');
  var declineBtn = document.getElementById('exit-popup-decline');
  if (!overlay) return;
  var shown = false;
  function show() {
    if (shown) return; shown = true;
    sessionStorage.setItem(KEY, '1');
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }
  function hide() { overlay.style.display = 'none'; document.body.style.overflow = ''; }
  document.addEventListener('mouseleave', function(e) { if (e.clientY <= 0) show(); });
  var idleTimer;
  function resetIdle() { clearTimeout(idleTimer); idleTimer = setTimeout(show, 30000); }
  ['touchstart','touchmove','scroll'].forEach(function(ev) { document.addEventListener(ev, resetIdle, { passive: true }); });
  resetIdle();
  if (closeBtn) closeBtn.addEventListener('click', hide);
  if (declineBtn) declineBtn.addEventListener('click', hide);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) hide(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') hide(); });
})();

window.rwHandleExitPopupSubmit = function(e) {
  e.preventDefault();
  var btn = e.target.querySelector('button[type="submit"]');
  if (btn) { btn.textContent = '✓ CHECK YOUR EMAIL!'; btn.disabled = true; btn.style.background = '#25D366'; }
  setTimeout(function() {
    var overlay = document.getElementById('exit-popup-overlay');
    if (overlay) { overlay.style.display = 'none'; document.body.style.overflow = ''; }
  }, 2200);
};

/* ---- QUICK VIEW MODAL ---- */
window.rwOpenQuickView = function(btn) {
  var overlay = document.getElementById('quick-view-overlay');
  if (!overlay) return;
  var title = btn.dataset.productTitle || '';
  var price = btn.dataset.productPrice || '';
  var comparePrice = btn.dataset.productComparePrice || '';
  var url = btn.dataset.productUrl || '#';
  var image = btn.dataset.productImage || '';
  var desc = btn.dataset.productDesc || '';
  document.getElementById('quick-view-title').textContent = title;
  document.getElementById('quick-view-price').textContent = price;
  var cmp = document.getElementById('quick-view-compare-price');
  if (cmp) { cmp.textContent = comparePrice; cmp.style.display = comparePrice ? 'inline' : 'none'; }
  document.getElementById('quick-view-desc').textContent = desc;
  var imgEl = document.getElementById('quick-view-image');
  if (imgEl) { imgEl.src = image; imgEl.alt = title; imgEl.style.display = image ? 'block' : 'none'; }
  var link = document.getElementById('quick-view-details-link');
  if (link) link.href = url;
  var cartBtn = document.getElementById('quick-view-cart-btn');
  if (cartBtn) cartBtn.href = url;
  var waBtn = document.getElementById('quick-view-wa-btn');
  if (waBtn) {
    var msg = encodeURIComponent('Hello! I want to order ' + title + ' from Raja Waqar. Please confirm availability.');
    waBtn.href = 'https://wa.me/923335338411?text=' + msg;
  }
  document.querySelectorAll('#quick-view-sizes .rw-size-swatch').forEach(function(s, i) { s.classList.toggle('active', i === 0); });
  overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';
};

/* Also support legacy openQuickView calls from w-luxury sections */
window.openQuickView = window.rwOpenQuickView;

(function rwInitQuickViewClose() {
  var overlay = document.getElementById('quick-view-overlay');
  var closeBtn = document.getElementById('quick-view-close');
  if (!overlay) return;
  function close() { overlay.style.display = 'none'; document.body.style.overflow = ''; }
  if (closeBtn) closeBtn.addEventListener('click', close);
  overlay.addEventListener('click', function(e) { if (e.target === overlay) close(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && overlay.style.display === 'flex') close(); });
})();

/* ---- SIZE SELECTOR ---- */
window.rwSelectSize = function(btn, size) {
  var parent = btn.closest('.rw-size-swatches');
  if (parent) parent.querySelectorAll('.rw-size-swatch').forEach(function(s) { s.classList.remove('active'); });
  btn.classList.add('active');
};
window.selectSize = window.rwSelectSize;

/* ---- BUNDLE BUILDER ---- */
(function rwInitBundleBuilder() {
  var selected = [];
  var bundleSize = 2;
  var discounts = { 2: 0.10, 3: 0.15 };

  // ⚠️ REPLACE this number with your actual Pro 2 Earbuds variant ID from Shopify Admin
  var FREE_GIFT_VARIANT_ID = 53307859763497;

  // Names to detect for the free gift trigger (partial match, case-insensitive)
  var GIFT_TRIGGER_A = 'victos';
  var GIFT_TRIGGER_B = 'khamrez';

  window.selectBundleSize = function(btn, size) {
    bundleSize = size;
    document.querySelectorAll('.bundle-tab').forEach(function(t) { t.classList.remove('active'); });
    btn.classList.add('active');
    var instr = document.getElementById('bundle-instruction');
    if (instr) instr.innerHTML = 'Select any <strong>' + size + '</strong> fragrances below:';
    while (selected.length > bundleSize) {
      var rem = selected.pop();
      var card = document.querySelector('[data-product-id="' + rem.id + '"]');
      if (card) { card.classList.remove('selected'); card.setAttribute('aria-checked','false'); }
    }
    rwUpdateBundle();
  };

  window.toggleBundleProduct = function(card) {
    var id = card.dataset.productId;
    var name = card.dataset.productName;
    var price = parseFloat(card.dataset.productPrice) || 0;
    var idx = selected.findIndex(function(p) { return p.id === id; });
    if (idx > -1) {
      selected.splice(idx, 1);
      card.classList.remove('selected');
      card.setAttribute('aria-checked', 'false');
    } else {
      if (selected.length >= bundleSize) {
        var removed = selected.shift();
        var oldCard = document.querySelector('[data-product-id="' + removed.id + '"]');
        if (oldCard) {
          oldCard.classList.remove('selected');
          oldCard.setAttribute('aria-checked', 'false');
        }
      }
      // ✅ CHANGE 1: now stores variantId from data-variant-id attribute
      selected.push({
        id: id,
        variantId: card.dataset.variantId,
        name: name,
        price: price
      });
      card.classList.add('selected');
      card.setAttribute('aria-checked', 'true');
    }
    rwUpdateBundle();
  };

  // ✅ CHANGE 2: new rwUpdateBundle — prices + selected list + FREE gift banner
  function rwUpdateBundle() {
    var total = selected.reduce(function(s, p) { return s + p.price; }, 0);
    var rate = selected.length >= bundleSize ? (discounts[bundleSize] || 0) : 0;
    var disc = total * rate;
    var final = total - disc;

    var el = function(id) { return document.getElementById(id); };

    // Update price display
    if (el('bundle-original')) el('bundle-original').textContent = 'Rs. ' + Math.round(total).toLocaleString();
    if (el('bundle-discount-amount')) el('bundle-discount-amount').textContent = disc > 0 ? '- Rs. ' + Math.round(disc).toLocaleString() : 'Rs. 0';
    if (el('bundle-final')) el('bundle-final').textContent = 'Rs. ' + Math.round(final).toLocaleString();
    if (el('bundle-add-btn')) el('bundle-add-btn').disabled = selected.length < bundleSize;

    // Update selected items list
    if (el('bundle-selected-list')) {
      el('bundle-selected-list').innerHTML = selected.length === 0
        ? '<p class="bundle-empty-msg">No items selected yet</p>'
        : selected.map(function(p) {
            return '<div class="bundle-selected-item">✓ ' + p.name + '</div>';
          }).join('');
    }

    // Detect Victos + Khamrez for FREE gift banner
    var names = selected.map(function(p) { return p.name.toLowerCase(); });
    var hasVictos  = names.some(function(n) { return n.indexOf(GIFT_TRIGGER_A) !== -1; });
    var hasKhamrez = names.some(function(n) { return n.indexOf(GIFT_TRIGGER_B) !== -1; });
    var giftEarned = hasVictos && hasKhamrez;

    var giftBanner = el('bundle-gift-banner');
    if (giftBanner) {
      giftBanner.style.display = giftEarned ? 'flex' : 'none';
    }
  }

  // ✅ CHANGE 3: real Shopify addBundleToCart — adds perfumes + FREE Earbuds + redirects to cart
  window.addBundleToCart = function() {
    if (selected.length < bundleSize) return;

    var btn = document.getElementById('bundle-add-btn');
    if (btn) { btn.textContent = 'ADDING...'; btn.disabled = true; }

    // Build items array: one entry per selected perfume
    var items = selected.map(function(p) {
      return { id: parseInt(p.variantId), quantity: 1 };
    });

    // Check if free gift should be added
    var names = selected.map(function(p) { return p.name.toLowerCase(); });
    var hasVictos  = names.some(function(n) { return n.indexOf(GIFT_TRIGGER_A) !== -1; });
    var hasKhamrez = names.some(function(n) { return n.indexOf(GIFT_TRIGGER_B) !== -1; });
    if (hasVictos && hasKhamrez) {
      items.push({ id: FREE_GIFT_VARIANT_ID, quantity: 1 });
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    })
    .then(function() {
      rwUpdateCartCount();
      // Redirect to cart page
      window.location.href = '/cart';
    })
    .catch(function(err) {
      console.error('Bundle add to cart error:', err);
      if (btn) { btn.textContent = 'TRY AGAIN'; btn.disabled = false; }
    });
  };

  // ✅ CHANGE 4: variant selector — updates card + selected[] if card already picked
  window.rwBundleVariantChange = function(event, select) {
    event.stopPropagation();
    var card = select.closest('.bundle-product-card');
    var selectedOption = select.options[select.selectedIndex];
    var variantId = select.value;
    var price = parseInt(selectedOption.dataset.price);
    card.setAttribute('data-variant-id', variantId);
    card.setAttribute('data-product-price', price);
    var priceEl = card.querySelector('.bundle-product-price');
    if (priceEl) priceEl.textContent = 'Rs. ' + price.toLocaleString();
    // If card is already in selected[], update its variantId + price and recalculate
    var id = card.dataset.productId;
    var entry = selected.find(function(p) { return p.id === id; });
    if (entry) {
      entry.variantId = variantId;
      entry.price = price;
      rwUpdateBundle();
    }
  };

})();

/* ---- FRAGRANCE TABS ---- */
window.switchFragranceTab = function(btn, tabId) {
  document.querySelectorAll('.fragrance-tab').forEach(function(t) { t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
  btn.classList.add('active'); btn.setAttribute('aria-selected','true');
  document.querySelectorAll('.fragrance-tab-content').forEach(function(p) { p.classList.add('hidden'); });
  var panel = document.getElementById('tab-' + tabId);
  if (panel) panel.classList.remove('hidden');
};

/* ---- STICKY ATC BAR ---- */
(function rwInitStickyBar() {
  var bar = document.getElementById('sticky-atc-bar');
  if (!bar) return;
  var origArea = document.querySelector('.rw-product__add-form, .product-form, .rw-product__footer');
  window.addEventListener('scroll', function() {
    var top = window.scrollY || document.documentElement.scrollTop;
    if (origArea) {
      var rect = origArea.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < window.innerHeight) { bar.classList.remove('visible'); return; }
    }
    if (top > 300) bar.classList.add('visible'); else bar.classList.remove('visible');
  }, { passive: true });
})();

window.stickyAddToCart = function() {
  var btn = document.getElementById('sticky-atc-btn');
  if (!btn) return;
  var variantId = btn.dataset.variantId;
  if (!variantId) return;
  var orig = btn.textContent;
  btn.textContent = 'ADDING...'; btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  }).then(function(r) { return r.json(); })
  .then(function() {
    btn.textContent = '✓ ADDED!'; btn.style.background = '#25D366';
    rwUpdateCartCount();
    var notif = document.getElementById('rw-cart-notification');
    if (notif) { notif.hidden = false; setTimeout(function() { notif.hidden = true; }, 3500); }
    setTimeout(function() { btn.textContent = orig; btn.style.background = ''; btn.disabled = false; }, 2000);
  }).catch(function() { btn.textContent = orig; btn.disabled = false; });
};

/* ---- CART COUNT UPDATER ---- */
function rwUpdateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var el = document.querySelector('.rw-cart-count');
      if (cart.item_count > 0) {
        if (el) { el.textContent = cart.item_count; }
        else {
          var cartLink = document.querySelector('.rw-header__icon[href*="cart"]');
          if (cartLink) {
            var badge = document.createElement('span');
            badge.className = 'rw-cart-count';
            badge.textContent = cart.item_count;
            cartLink.appendChild(badge);
          }
        }
      }
    }).catch(function() {});
}

/* ---- ANNOUNCEMENT BAR MARQUEE: PAUSE ON HOVER ---- */
(function rwInitMarquee() {
  var bar = document.querySelector('.rw-announcement');
  if (!bar) return;
  bar.addEventListener('mouseenter', function() {
    var track = bar.querySelector('.marquee-content');
    if (track) track.style.animationPlayState = 'paused';
  });
  bar.addEventListener('mouseleave', function() {
    var track = bar.querySelector('.marquee-content');
    if (track) track.style.animationPlayState = 'running';
  });
})();
/* ============================================
   SCENT PROFILE PANEL — Animated Gold Bars
   ============================================ */
(function () {
  function runBars(panel) {
    panel.querySelectorAll('.rw-scent-panel__bar[data-width]').forEach(function (bar) {
      bar.style.width = bar.getAttribute('data-width') + '%';
    });
  }
  function initScentBars() {
    var panel = document.querySelector('.rw-scent-panel');
    if (!panel) return;
    panel.querySelectorAll('.rw-scent-panel__bar[data-width]').forEach(function (bar) {
      bar.style.width = '0%';
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          runBars(entry.target);
          obs.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
      io.observe(panel);
    } else {
      runBars(panel);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScentBars);
  } else {
    initScentBars();
  }
})();